module.exports = __webpack_public_path__ + "static/img/kitchen3.3032e19.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/kitchen3.jpg
// module id = VFaQ
// module chunks = 0